  <h2 mat-dialog-title>    
    <p>Add Link </p>        
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
    
  </h2>

<mat-dialog-content>
  
    <div class="divideCol">
      <mat-form-field>
        <mat-label>Link</mat-label>
        <input matInput  placeholder="Enter link" />       
      </mat-form-field>    
    </div>   

  </mat-dialog-content>
  
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>

   <div class="button-row">
  <button mat-flat-button class="calltoaction" type="submit" color="primary">
    <mat-icon *ngIf="spinner">
      <mat-spinner diameter="20"></mat-spinner>
    </mat-icon>
    Crawl
  </button>

  <button mat-flat-button class="calltoaction" type="submit" color="primary">
    <mat-icon *ngIf="spinner">
      <mat-spinner diameter="20"></mat-spinner>
    </mat-icon>
    Add Link
  </button>
</div>
  
  </mat-dialog-actions>



  

  




